import React, { useState, useEffect } from "react";
import {
  Input,
  Form,
  Col,
  Row,
  Button,
  Select,
  notification,
  Upload,
  Empty,
  Checkbox,
} from "antd";
import {
  PlusOutlined,
  DownloadOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import ScreenOptions from "../../util/Extensions/Screens";
import config from "../../util/ApiforContext";
import { odata, queryHelper } from "../Filters/Helper";
const { TextArea } = Input;

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    md: {
      span: 24,
    },
    lg: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    md: {
      span: 24,
    },
    lg: {
      span: 12,
    },
  },
};

const AccountTransactionRuleUpdateForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [firmSelect, setFirmSelect] = useState({
    data: [],
    loading: false,
  });
  const [firmClassDropdown, setfirmClassDropdown] = useState({
    data: [],
    loading: false,
  });
  const [operationType2, setOperationType2] = useState();
  const [projectSelect, setProjectSelect] = useState({
    data: [],
    loading: false,
  });

  const [tenantAccountSelect, setTenantAccountSelect] = useState({
    data: [],
    loading: true,
  });

  const operationTypes = [
    { "id": "0", "name": "Belirtilmemiş" },
    { "id": "1", "name": "Nakit" },
    { "id": "4", "name": "Banka masrafı" },
    { "id": "5", "name": "Stopaj kesintisi" },
    { "id": "6", "name": "Damga vergisi" },
    { "id": "7", "name": "Stopaj üzerinden fon kesintisi" },
    { "id": "8", "name": "Çek tahsilatı" },
    { "id": "9", "name": "Repo Açılış/geri dönüş" },
    { "id": "10", "name": "Vadeli hesap açılışı/ geri dönüş" },
    { "id": "11", "name": "Kredi açılış/kapanış" },
    { "id": "12", "name": "Firma hesaplar arası virman" },
    { "id": "13", "name": "Senet tahsilatı" },
    { "id": "14", "name": "İhracat tahsilatı" },
    { "id": "15", "name": "İthalat ödemesi" },
    { "id": "16", "name": "Döviz alış/satışı" },
    { "id": "17", "name": "Faiz gelir/gideri" },
    { "id": "18", "name": "Karşılıksız senet protesto masrafı" },
    { "id": "19", "name": "Doğrudan borçlandırma" },
    { "id": "20", "name": "KKDF Ödemesi" },
    { "id": "21", "name": "Repo faiz geliri" },
    { "id": "22", "name": "Bono alış/satışı" },
    { "id": "23", "name": "Yatırım fonu alış/satışı" },
    { "id": "24", "name": "İthalat masrafı" },
    { "id": "25", "name": "Teminat mektubu komisyonu" },
    { "id": "26", "name": "Fatura ödemesi" },
    { "id": "27", "name": "Kurumlar fatura" },
    { "id": "28", "name": "BSMV" },
    { "id": "29", "name": "Akreditif ödemesi" },
    { "id": "30", "name": "Akreditif komisyonu" },
    { "id": "31", "name": "Akreditif masrafı" },
    { "id": "999", "name": "Diğer işlemler" }
  ];
  
  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }

    if (props.data.firmId !== null) {
      getFirms();
    }
    if (props.data.transactionProjectTypeId !== null) {
      getProjects();
    }
    if (props.data.tenantAccountId !== null) {
      getAccounts();
    }
  }, [props.data]);

  useEffect(() => {
    if (props.isUseForErp == true) {
      RequestHandler.get(`/FirmClass?$filter=isErpType eq true`).then(
        (response) => {
          setfirmClassDropdown({ data: response.value, loading: false });
        }
      );
    } else {
      RequestHandler.get(`/FirmClass`).then((response) => {
        setfirmClassDropdown({ data: response.value, loading: false });
      });
    }
    RequestHandler.get("/TenantErpProgram/GetByTenant").then((response) => {
      if (response) {
        setOperationType2(response.isOperationType2);
      }
    });
  }, []);

  const onSuccess = () => {
    form.resetFields();

    if (props.onSuccess) props.onSuccess();
  };

  const onFinish = (values) => {
    if (values.transactionProcessType === 0) {
      values.transactionProcessType = null;
    }
    RequestHandler.put(`/AccountTransactionRule`, values)
    .then((response) => {
      setLoading(false);
      if (response.success) {
        onSuccess();
      }
    }).catch(function (error) {
      setLoading(false);
    });
  };

  const onFinishFailed = (errorInfo) => {
    setLoading(false);
  };

  const onFirmSearch = (value) => {
    if (value.length >= 2) {
      setFirmSelect({ ...firmSelect, loading: true });

      RequestHandler.get(
        `/Firm?$select=id,firmBranchNumber,name&$filter=${odata.contains(
          "name",
          value
        )} or ${odata.contains("firmBranchNumber", value)}`
      ).then((res) => {
        setFirmSelect({ data: res.value, loading: false });
      });
    } else {
      setFirmSelect({ data: [], loading: false });
    }
  };

  const getFirms = () => {
    setFirmSelect({
      ...firmSelect,
      loading: true,
    });
    RequestHandler.get(
      `/Firm?$select=id,firmBranchNumber,name&$filter=id eq ${props.data.firmId}`
    ).then((response) => {
      setFirmSelect({
        data: response.value,
        loading: false,
      });
    });
  };

  const onProjectSearch = (value) => {
    if (value.length >= 2) {
      setProjectSelect({ data: [], loading: true });

      RequestHandler.get(
        `/TransactionProjectType?$select=id,projectCode,name&$filter=(${odata.contains(
          "name",
          value
        )} or ${odata.contains("projectCode", value)})  and Name ne 'Diğer'`
      ).then((res) => {
        setProjectSelect({ data: res.value, loading: false });
      });
    } else {
      setProjectSelect({ data: [], loading: false });
    }
  };

  const getProjects = () => {
    setProjectSelect({
      ...projectSelect,
      loading: true,
    });
    RequestHandler.get(
      `/TransactionProjectType?$select=id,projectCode,name&$filter=id eq ${props.data.transactionProjectTypeId}`
    ).then((response) => {
      setProjectSelect({
        data: response.value,
        loading: false,
      });
    });
  };

  const getAccounts = () => {
    setTenantAccountSelect({
      ...tenantAccountSelect,
      loading: true,
    });
    RequestHandler.get(
      `/TenantAccount?$filter=id eq ${props.data.tenantAccountId}`
    ).then((response) => {
      setTenantAccountSelect({
        data: response.value,
        loading: false,
      });
    });
  };

  const onAccountSearch = (value) => {
    if (value.length >= 2) {
      setTenantAccountSelect({ data: [], loading: true });

      RequestHandler.get(`/TenantAccount?$filter=bankId ne 999`).then((res) => {
        setTenantAccountSelect({ data: res.value, loading: false });
      });
    } else {
      setTenantAccountSelect({ data: [], loading: false });
    }
  };

  return (
    <Form
      {...formItemLayout}
      form={form}
      name="AccountTransactionRuleAdd"
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Row>
        <Col span={24}>
          <Form.Item name="id" hidden>
            <Input />
          </Form.Item>
          <Form.Item
            label="Kural Adı"
            name="name"
            rules={[
              { required: true, message: "Lütfen Kural adını boş bırakmayın." },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item label="Banka Hesabı" name="tenantAccountId">
            <Select
              allowClear
              showSearch
              placeholder="En az 2 harf giriniz.."
              onSearch={onAccountSearch}
              style={{ width: "100%" }}
              dropdownStyle={{ minWidth: "30%" }}
              filterOption={(input, option) =>
                option.props.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
              loading={tenantAccountSelect.loading}
            >
              {tenantAccountSelect.data.map(
                ({
                  id,
                  name,
                  currencyId,
                  currency,
                  bankName,
                  accountNumber,
                  iban,
                }) => (
                  <Select.Option
                    key={id}
                    value={id}
                    currencyId={currencyId}
                    bankName={bankName}
                    accountNumber={accountNumber}
                    iban={iban}
                  >
                    {name
                      ? `${name} (${currency})`
                      : ` ${bankName} (${
                          accountNumber ? accountNumber : iban
                        }) (${currency})`}
                  </Select.Option>
                )
              )}
            </Select>
          </Form.Item>

          <Form.Item
            label="Hesap Hareketi İşlem Tipi"
            name="transactionProcessType"
          >
            <Select
              allowClear
              placeholder="Tümü"
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
            >
              <Select.Option key={0} value={0}>
                Tümü
              </Select.Option>
              <Select.Option key={1} value={1}>
                Tahsilat
              </Select.Option>
              <Select.Option key={2} value={2}>
                Ödeme
              </Select.Option>
            </Select>
          </Form.Item>

          

          <Form.Item
            label="Kural Metni"
            name="key"
            rules={[
              {
                required: true,
                message: "Lütfen Kural Metni alanını boş bırakmayın.",
              },
            ]}
          >
            <TextArea rows={4} />
          </Form.Item>

          <Form.Item label="Ek Kural Metni" name="additionalKey">
            <TextArea rows={4} />
          </Form.Item>

          <Form.Item label="Açıklama" name="replaceKey">
            <TextArea rows={4} />
          </Form.Item>

          {/* <Form.Item label="Belge Tipi" name="documentType">
            <Input />
          </Form.Item> */}

          <Form.Item
            label={props.isUseForErp == true ? "İşlem Tipi" : "Bayi Sınıfı"}
            name="firmClassId"
          >
            <Select
              allowClear
              showSearch
              placeholder="Seçiniz"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.props.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
            >
              {firmClassDropdown.data.map((item) => (
                <Select.Option key={item.id} value={item.id}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item name="operationType" label="İşlem Türü :">
            <Select allowClear placeholder="Seçiniz">
            {operationTypes.map((item) => (
                <Select.Option key={item.id} value={item.id}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          
          {operationType2 && (
            <Form.Item name="operationType2" label="2.İşlem Türü :">
              <Select allowClear placeholder="Tümü">
                {operationTypes.map((item) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          )}

          <Form.Item
            label={props.isUseForErp == true ? "Erp Kodu" : "Bayi Adı"}
            name="firmId"
          >
            <Select
              allowClear
              showSearch
              placeholder="Seçiniz"
              onSearch={onFirmSearch}
              style={{ width: "100%" }}
              dropdownStyle={{ minWidth: "30%" }}
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                option.code
                  ?.toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
              loading={firmSelect.loading}
            >
              {firmSelect.data.map((item) => (
                <Select.Option
                  key={item.id}
                  value={item.id}
                  code={item.firmBranchNumber}
                >
                  {item.name + " (" + item.firmBranchNumber + ")"}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          {props.isUseForErp == true && (
            <Form.Item label="Referans Kodu" name="referenceCode">
              <Input />
            </Form.Item>
          )}

          {props.isUseForErp == true && (
            <Form.Item label="Proje Kodu" name="transactionProjectTypeId">
              <Select
                allowClear
                showSearch
                placeholder="En az 2 harf giriniz.."
                onSearch={onProjectSearch}
                style={{ width: "100%" }}
                dropdownStyle={{ minWidth: "30%" }}
                filterOption={(input, option) =>
                  option.children
                    .toLocaleLowerCase("tr-TR")
                    .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                  option.code
                    .toLocaleLowerCase("tr-TR")
                    .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                }
                loading={projectSelect.loading}
              >
                {projectSelect.data.map((item) => (
                  <Select.Option
                    key={item.id}
                    value={item.id}
                    code={item.projectCode}
                  >
                    {item.name + " (" + item.projectCode + ")"}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          )}

         { props.isActiveAutoTransfer == true && ( <Form.Item label="Otomatik Aktarım'da kullanılsın" name="isAutoTransfer" valuePropName="checked"><Checkbox  /></Form.Item>)}

          {/* 
          <Form.Item label="Muhasebe Kodu" name="accountingCode">
            <Input />
          </Form.Item>

     

   
          <Form.Item
            label="Sorumluluk Merkezi"
            name="centerOfResponsibilityCode"
          >
            <Input />
          </Form.Item> */}

          <Row justify="space-between">
            <Col span={6}></Col>
            <Col span={6}></Col>
            <Col span={6}></Col>
            <Col span={6}>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                htmlType="submit"
                onClick={() => setLoading(true)}
                loading={loading}
              >
                Güncelle
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );
};
export default AccountTransactionRuleUpdateForm;
